import React from 'react'

import './truncated-list-with-count.scss'

import cn from '../../libs/class-names'
import {countChildrenWithFragments, mapChildrenWithFragments} from '../../services/react-children'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children?: React.ReactNode[]
    space?: 'default' | 'l'
    maxLength?: number
    showAll?: boolean
  }
>

const sliceList = (list: React.ReactNode[], maxLength: number) => {
  const truncatedList = list.slice(0, maxLength)
  const moreList = list.slice(maxLength)

  return [truncatedList, moreList] as const
}

const TruncatedListWithCount = ({
  className,
  children,
  maxLength = 5,
  showAll,
  space = 'default',
  ...props
}: Props) => {
  const [list, more] = sliceList(
    mapChildrenWithFragments(children, child => child),
    showAll ? countChildrenWithFragments(children) : maxLength
  )

  return (
    <div
      {...props}
      className={cn('TruncatedListWithCount', {[`space-${space}`]: !!space}, className)}
    >
      {list}
      <div hidden>{more}</div>
      <span className="TruncatedListWithCount__count">
        {more.length > 0 ? `+${more.length}` : <>&nbsp;</>}
      </span>
    </div>
  )
}

export default TruncatedListWithCount
